/* egj-viewed.js — 棚（一覧）に「もう開いた品」の小さな印を出す
 * ============================================================================
 * なぜ在るか（2026-09-09 🐺ハリー・パワーアップ板 mi-260907-cd034e／👑が「やる」）
 *   Super Famicom の棚は213点＝1頁24点で9頁ある。よく似た本体が並ぶので、
 *   海外のお客さんは開いては戻り、開いては戻りを繰り返すうちに
 *   「さっき見たのはどれだったか」を見失い、同じ品をもう一度開く。
 *   そこで、一度でも開いた品の写真の隅に小さな印を出す。
 *
 * 掟（この4つを破らない）
 *   1. 覚えるのはその人の端末の中だけ（localStorage）。どこへも送らない。
 *      cookie も使わない・個人を特定する物は1バイトも持たない。
 *   2. 値段・在庫・並び順・商品名は1文字も触らない。足すのは印だけ。
 *   3. 印を出す棚は ENABLED_SHELVES に書いた分だけ。
 *      空なら何もしない＝入れる前と1ピクセルも変わらない（半分だけ試すための栓）。
 *   4. 例外が出ても店を壊さない。全部 try/catch の中で動く。
 *
 * 見る（👑の下見用）: 棚のURLの末尾に ?egj_preview=viewed を付けると、
 *   ENABLED_SHELVES に関係なくその場だけ印が出る。他のお客さんには出ない。
 *
 * 割り付けの紙: metrics/honten_shelf_ui_experiments.json（唯一の住所）
 */
(function () {
  'use strict';

  /* ── 栓は2つ ────────────────────────────────────────────────────
     LIVE ... 👑のGOが出た日に true にする。false の間はどのお客さんの画面も
              1ピクセルも変わらないし、端末に何も書かない。
     ENABLED_SHELVES ... 印を出す棚（A組）。90日さわらないC組を絶対に入れない。
     🔴 唯一の住所 = metrics/honten_shelf_ui_experiments.json の groups.A.shelves
        （2026-09-09 に凍らせた紙。ここを変えたら実験が死ぬ） */
  var LIVE = true;
  var ENABLED_SHELVES = [
    'playstation-2',
    'pc-engine',
    'gameboy',
    'nintendo-64',
    'xbox',
    'sega-saturn',
    'virtual-boy'
  ];
  /* ────────────────────────────────────────────────────────────── */

  var KEY = 'egj_viewed_v1';
  var TTL_DAYS = 60;   // 60日たった記憶は忘れる（古い印は迷いを増やす）
  var CAP = 300;       // 端末に貯める上限（古い物から捨てる）
  var LABEL = 'Viewed';
  var TITLE = 'You have opened this item before';

  function today() { return Math.floor(Date.now() / 86400000); }

  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return {};
      var o = JSON.parse(raw);
      if (!o || o.v !== 1 || typeof o.items !== 'object' || !o.items) return {};
      var now = today(), out = {};
      for (var h in o.items) {
        if (!Object.prototype.hasOwnProperty.call(o.items, h)) continue;
        var d = o.items[h];
        if (typeof d === 'number' && now - d <= TTL_DAYS) out[h] = d;
      }
      return out;
    } catch (e) { return {}; }
  }

  function save(items) {
    try {
      var keys = Object.keys(items);
      if (keys.length > CAP) {
        keys.sort(function (a, b) { return items[b] - items[a]; });
        var kept = {};
        for (var i = 0; i < CAP; i++) kept[keys[i]] = items[keys[i]];
        items = kept;
      }
      window.localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items }));
    } catch (e) { /* 端末が拒否したら黙って諦める＝店は壊さない */ }
  }

  /* URL から品名（handle）を取り出す。/collections/x/products/y でも y を返す。
     decodeURIComponent は壊れた%エンコードで投げるので必ず包む（チューリング指摘 2026-09-09）。 */
  function handleOf(path) {
    var m = /\/products\/([^/?#]+)/.exec(path || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  /* いま見ているのが棚なら、その棚の名前（handle）を返す。 */
  function shelfOf(path) {
    if (handleOf(path)) return null;               // 商品ページは棚ではない
    var m = /\/collections\/([^/?#]+)/.exec(path || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  var path = window.location.pathname;
  /* 下見モード。一度 ?egj_preview=viewed を付けて開いたら、そのタブの間はそのまま
     （商品を開いて棚へ戻った時に印が消えると「壊れた」に見えるため）。
     タブを閉じれば終わり＝他のお客さんには一切関係しない。 */
  var preview = /(^|[?&])egj_preview=viewed(&|$)/.test(window.location.search);
  try {
    if (preview) window.sessionStorage.setItem('egj_preview', '1');
    else if (window.sessionStorage.getItem('egj_preview') === '1') preview = true;
  } catch (e) { /* 使えなければ下見はURL1枚きり */ }

  /* ── ①商品ページ＝「開いた」を覚える ───────────────────────────── */
  var prod = handleOf(path);
  if (prod) {
    if (!preview && (!LIVE || ENABLED_SHELVES.length === 0)) return; // 栓が閉じている＝何もしない
    var items = load();
    items[prod] = today();
    save(items);
    return;
  }

  /* ── ②棚＝覚えている品に印を出す ───────────────────────────────── */
  var shelf = shelfOf(path);
  if (!shelf) return;
  if (!preview && (!LIVE || ENABLED_SHELVES.indexOf(shelf) === -1)) return;

  var seen = load();
  if (!preview && Object.keys(seen).length === 0) return;

  function injectStyle() {
    if (document.getElementById('egj-viewed-style')) return;
    var s = document.createElement('style');
    s.id = 'egj-viewed-style';
    s.textContent =
      '.egj-viewed-badge{position:absolute;top:.6rem;left:.6rem;z-index:3;' +
      'display:inline-flex;align-items:center;gap:.3em;' +
      'padding:.25em .6em;border-radius:999px;' +
      'background:rgba(18,18,18,.78);color:#fff;' +
      'font-size:1.1rem;line-height:1.5;letter-spacing:.02em;' +
      'font-weight:500;pointer-events:none;' +
      '-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}' +
      '.egj-viewed-badge--right{left:auto;right:.6rem;}' +
      '.egj-viewed-badge svg{width:1em;height:1em;flex:0 0 auto;}' +
      '@media screen and (max-width:749px){.egj-viewed-badge{top:.4rem;left:.4rem;font-size:1rem;}' +
      '.egj-viewed-badge--right{left:auto;right:.4rem;}}' +
      '@media (prefers-reduced-motion:no-preference){.egj-viewed-badge{transition:opacity .15s;}}';
    document.head.appendChild(s);
  }

  /* Sold out / Sale の札は設定 settings.badge_position で位置が動く（2026-09-09 実測は
     "bottom left"＝ぶつからない）。設定を後から左上に変えられても重ならないよう、
     左上に先客が居たら自分が右上へ避ける。 */
  function occupiesTopLeft(card) {
    var b = card.querySelector('.card__badge');
    if (!b) return false;
    return b.classList.contains('top') && b.classList.contains('left');
  }

  function badge(dodgeRight) {
    var b = document.createElement('span');
    b.className = 'egj-viewed-badge' + (dodgeRight ? ' egj-viewed-badge--right' : '');
    b.setAttribute('title', TITLE);
    b.innerHTML =
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M6.2 12.1 2.4 8.3l1.3-1.3 2.5 2.5 6.1-6.1 1.3 1.3z"/></svg>' +
      '<span>' + LABEL + '</span>';
    return b;
  }

  function mark() {
    try {
      var cards = document.querySelectorAll('.card-wrapper');
      if (!cards.length) return;
      injectStyle();
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card.querySelector('.egj-viewed-badge')) continue;
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) continue;
        var h = handleOf(link.getAttribute('href') || '');
        if (!h) continue;
        if (!preview && !Object.prototype.hasOwnProperty.call(seen, h)) continue;
        var host = card.querySelector('.card__inner') || card;
        var pos = window.getComputedStyle(host).position;
        if (pos === 'static') host.style.position = 'relative';
        host.appendChild(badge(occupiesTopLeft(card)));
      }
    } catch (e) { /* 印が出ないだけ＝棚はそのまま */ }
  }

  function start() {
    mark();
    /* 絞り込みや「もっと見る」で棚が差し替わっても付け直す */
    try {
      var grid = document.getElementById('ProductGridContainer') || document.body;
      var obs = new MutationObserver(function () { mark(); });
      obs.observe(grid, { childList: true, subtree: true });
    } catch (e) { /* 監視できなければ初回だけ */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
